import { gql } from "lib/apolloClient";

export const workflowProgressFragment = {
  workflowProgress: gql`
    fragment workflowProgress on IntegrationFetchWorkflowProgressDataResponse {
      nodes {
        localeKey
        status
        stepType
        stepOrder
        allowRetry
        data
      }
      stepCountByType
      steps {
        stepType
        stepOrder
        status
        allowRetry
        data
      }
      subTaskData {
        id
        createdAt
        parsedData
        status
      }
    }
  `,
};
